import React from 'react';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from '../utils/tracking';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    trackWhatsAppClick();
    window.open('https://wa.me/40726375166', '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20BA5C] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-110"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="text-white" size={26} />
    </button>
  );
};

export default WhatsAppButton;
